import React from 'react';
import '../tailwind.css';
import '../stitches.css';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { FaExternalLinkAlt} from "react-icons/fa";

const publications = [
  {
    text: "ATAC-seq pipeline",
    url: "https://github.com/Zhang-lab/TaRGET-II-ATACseq-pipeline" 
  },
  {
    text: "RNA-seq pipeline",
    url: "https://github.com/Zhang-lab/TaRGET-II-RNAseq-pipeline" 
  }
];
const Software = () => {
  return (
    <div className='flex flex-col justify-between h-screen pt-4'>
      <div className='border-b-2 border-grey-light'>
        <Nav/>
      </div>
      <section className='container m-auto border-b-4 my-8'>
        <h3>Standardized Pipelines for uniformly processed data</h3>
        {publications.map((d, index) => <div className="flex py-3">
          <div className="w-1/8">
          </div>
          <div className="w-7/8">
            {/* <div>
              <span className="font-bold"><a href="#" className="text-black">Natalie Rushman</a></span>
              <span className="text-gray-700">@natalie</span>
              <span className="text-gray-700">·</span>
              <span className="text-gray-700">May 26</span>
            </div> */}
            <div className="">
              <p className="my-3 text-sm">{d.text}</p>
              <div className="pb-2 flex">
                {/* <h1 className="text-red mx-8"><FaFilePdf/></h1> */}
                <span>
                  <a
                    href={d.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="no-underline hover:text-blue">
                    <FaExternalLinkAlt/>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>)}
      </section>
      <Footer/>
    </div>
  );
}

export default Software;